export default [{
  path: '/service/index',
  name: 'service-index',
  title: '订单',
  redirect: '/service/all',
  component: () => import('@/views/service/index'),
  children: [{
    path: '/service/all',
    name: 'service-all',
    title: '订单',
    component: () => import('@/views/service/template/all/index')
  }, {
    path: '/service/all',
    name: 'service-order',
    title: '订单',
    component: () => import('@/views/service/template/order/index')
  }, {
    path: '/service/service',
    name: 'service-service',
    title: '服务开单记录',
    component: () => import('@/views/service/template/service/index')
  }, {
    path: '/service/quick',
    name: 'service-quick',
    title: '快捷收银记录',
    component: () => import('@/views/service/template/quick/index')
  }, {
    path: '/service/package',
    name: 'service-package',
    title: '套餐购买记录',
    component: () => import('@/views/service/template/package/index')
  }, {
    path: '/service/gift',
    name: 'service-gift',
    title: '赠送记录',
    component: () => import('@/views/service/template/gift/index')
  }]
}];
